import React from 'react'

export const FirebaseSetupInstructions: React.FC = () => (
  <div className="alert alert-destructive">
    <div className="alert-title">Firebase Setup Required</div>
    <div className="alert-description">
      <p>Your ratings couldn't be saved due to Firebase permission issues. To fix this:</p>
      <ol className="list-decimal list-inside mt-2 space-y-1">
        <li>Go to the <a href="https://console.firebase.google.com" target="_blank" rel="noopener noreferrer" className="underline">Firebase Console</a></li>
        <li>Select your project: <code className="bg-gray-200 px-1 rounded">pitstopromantico-99faa</code></li>
        <li>Navigate to <strong>Firestore Database</strong> → <strong>Rules</strong></li>
        <li>Update your rules to allow read/write access:</li>
      </ol>
      <div className="code-block mt-3">
        <div className="comment">// Allow read/write access to all users</div>
        <div>rules_version = <span className="text-green-400">'2'</span>;</div>
        <div><span className="keyword">service</span> cloud.firestore {`{`}</div>
        <div>  <span className="keyword">match</span> /databases/{`{database}`}/documents {`{`}</div>
        <div>    <span className="keyword">match</span> /{`{document=**}`} {`{`}</div>
        <div>      <span className="keyword">allow</span> read, write: <span className="keyword">if</span> <span className="text-green-400">true</span>;</div>
        <div>    {`}`}</div>
        <div>  {`}`}</div>
        <div>{`}`}</div>
      </div>
      <p className="mt-3 text-sm">
        <strong>Note:</strong> This allows public access. For production, implement proper authentication and security rules.
      </p>
    </div>
  </div>
)
